// ── AllChargeOffsPage ──
import { useState, useEffect } from "react";
import { B } from "../../../shared/theme";
import { exportCSV, fmt, fmtDate, localFilter } from "../../../shared/format";
import { Badge, Btn, Card, ErrorMsg, Icon, Pagination, STh, SearchBar, SectionHeader, Spinner, Td, TdNum, Th } from "../../../shared/ui";
import { usePagination, useSortable } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const AllChargeOffsPage = () => {
    const { api, role, view, setModal, setConfirm, delRec } = useApp();
      const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [err,setErr]=useState(null);
      const [q,setQ]=useState("");
      const load=()=>{setLoading(true);api.get("getChargeOffs").then(d=>{setRows(d);setLoading(false);}).catch(e=>{setErr(e.message);setLoading(false);});};
      useEffect(()=>{load();},[]);
      const filtered=localFilter(rows,q,["loannumber","companyname","status","asofdate"]);
      const { sorted, sortKey, sortDir, toggle } = useSortable(filtered, 'asofdate', 'desc');
      const { paginated:displayed, page, setPage, totalPages, total, reset } = usePagination(sorted, 100);

      const grandTotal = sorted.reduce((s,c)=>s+(parseFloat(c.amount)||0),0);

      if(loading) return <Spinner />; if(err) return <ErrorMsg msg={err} onRetry={load} />;
      return <>
        <SectionHeader actions={[
          <SearchBar key="s" value={q} onChange={v=>{ setQ(v); reset(); }} placeholder="Search charge-offs..." />,
          <Btn key="ex" onClick={()=>exportCSV(sorted,["loannumber","companyname","asofdate","amount","status"],"chargeoffs.csv")}>Export CSV</Btn>
        ]} />
        <Card style={{ overflowX:"auto" }}>
          <table style={{ width:"100%",borderCollapse:"collapse", whiteSpace:"nowrap" }}>
            <thead><tr>
              <STh label="Loan #"    sortKey="loannumber"  currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Account"   sortKey="companyname" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="As Of Date" sortKey="asofdate"   currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Amount"    sortKey="amount"      currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
              <STh label="Status"    sortKey="status"      currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <Th></Th>
            </tr></thead>
            <tbody>
              {displayed.map(c=>(
                <tr key={c.id} style={{ cursor:"pointer" }} onClick={()=>setModal({type:"chargeoff-view",rec:{...c,id:c.id,loanid:c.loanid}})} onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
                  <Td><span style={{ fontFamily:"var(--font-mono)",fontSize:12 }}>{c.loannumber}</span></Td>
                  <Td style={{ fontWeight:500 }}>{c.companyname}</Td>
                  <Td>{fmtDate(c.asofdate)}</Td>
                  <TdNum style={{ fontWeight:500 }}>{fmt(c.amount||0)}</TdNum>
                  <Td><Badge s={c.status} /></Td>
                  <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }} onClick={e=>e.stopPropagation()}>
                    <Btn onClick={()=>setModal({type:"chargeoff-view",rec:{...c,id:c.id,loanid:c.loanid}})}><Icon type="view" /></Btn>
                    {role.canEdit&&<Btn onClick={()=>setModal({type:"chargeoff-edit",rec:{...c,id:c.id,loanid:c.loanid},onDone:load})}><Icon type="edit" /></Btn>}
                    {role.canDelete&&<Btn onClick={()=>setConfirm({msg:"Delete this charge-off?",onConfirm:()=>delRec("ChargeOffs",c.id,"Deleted charge-off",load)})} variant="danger"><Icon type="delete" /></Btn>}
                  </div></Td>
                </tr>
              ))}

              {/* ── Grand total ── */}
              <tr style={{ background:B.cyanLight, borderTop:"2px solid "+B.cyan }}>
                <td colSpan={3} style={{ padding:"10px 12px", fontSize:13, fontWeight:700, color:B.cyanDark, textAlign:"right" }}>
                  Grand Total ({sorted.length} record{sorted.length!==1?"s":""})
                </td>
                <TdNum style={{ fontWeight:700, color:B.cyanDark }}>{fmt(grandTotal)}</TdNum>
                <td /><td />
              </tr>
            </tbody>
          </table>
          <Pagination page={page} totalPages={totalPages} total={total} pageSize={100} onPage={setPage} />
        </Card>
      </>;
    };
